import api from './api';

export default async function deleteAssetAudio(audio_id) {
    const { data } = await api.delete(`assets_audio/${audio_id}`);
    return data;
}